import React from 'react';
import { Field, RichText, SitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import './index.scss';

export type PaymentUnsuccessfulProps = {
  fields: {
    OrderUnsuccessfulText: Field<string>;
  };
  sitecoreContext: SitecoreContext & { pageEditing: boolean };
};

const PaymentUnsuccessful = (props: PaymentUnsuccessfulProps): React.JSX.Element => {
  const { fields } = props;

  return (
    <div className="paymentCenterContainer">
      <div className="paymentUnsuccessfulSection">
        <div className="paymentUnsuccessfulHeader">
          <h1>Payment Unsuccessful</h1>
        </div>
        <div className="paymentUnsuccessfulContent">
          <RichText className="paymentUnsuccessfulRichText" field={fields?.OrderUnsuccessfulText} />
        </div>
      </div>
    </div>
  );
};

export default PaymentUnsuccessful;
